import { axiosInstance } from 'boot/axios';
import isEmpty from 'lodash/isEmpty';
import Invoice from 'src/models/invoice.js';
import PaymentArrangement from 'src/models/paymentArrangement';

export function getInvoices({ commit, state, rootState }) {
  if (!rootState.user.permissions.mayReadInvoice) return;
  if (state.invoices?.length > 0) return;
  commit('setIsLoadingInvoices', true);
  return axiosInstance
    .get(`Debitan/Invoices`)
    .then((response) => {
      if (!isEmpty(response.data)) {
        commit(
          'setInvoices',
          response.data.invoices
            .map((invoice) => new Invoice(invoice))
            .filter((invoice) => invoice.invoiceDate.getFullYear() >= new Date().getFullYear() - 2)
            .sort(function (a, b) {
              return a.invoiceDate - b.invoiceDate;
            }),
        );
        commit('setIsPaymentArrangementsDisabled', response.data.isPaymentArrangementsDisabled);
      }
    })
    .finally(() => commit('setIsLoadingInvoices', false));
}

export function getPaymentArrangements({ commit, state }) {
  if (state.paymentArrangements?.length > 0) return;
  commit('setIsLoadingPaymentArrangements', true);
  return axiosInstance
    .get(`Debitan/PaymentArrangements`)
    .then((response) => {
      if (!isEmpty(response.data)) {
        commit(
          'setPaymentArrangements',
          response.data.paymentArrangments?.map((arrangement) => new PaymentArrangement(arrangement)),
        );
        commit('setHasUnproccessedPaymentArrangments', response.data.hasUnproccessedPaymentArrangments);
      }
    })
    .finally(() => commit('setIsLoadingPaymentArrangements', false));
}

export function postPaymentArrangement({ commit }, payload) {
  return axiosInstance.post('Debitan/PaymentArrangements', payload).finally(() => commit('setPaymentArrangements', []));
}

export function getInvoiceAttachments({ commit, state }, payload) {
  if (state.invoiceAttachmentIdsFetched.includes(payload)) return;
  commit('setIsLoadingAttachments', true);

  return axiosInstance
    .get(`Debitan/Invoices/${payload}/Attachments`)
    .then((response) => {
      if (!isEmpty(response.data)) {
        commit('addAttachmentToInvoice', { invoiceNumber: payload, attachments: response.data });
      }
    })
    .finally(() => commit('setIsLoadingAttachments', false));
}
